import {Component} from '@angular/core';
import {AlertController, IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {AccountProvider} from "../../providers/account/account";

/**
 * Generated class for the RegisterPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-register',
    templateUrl: 'register.html',
})
export class RegisterPage {
    isSuccessed = false;
    public model = {};

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        private accountProvider: AccountProvider,
        private alertCtrl: AlertController,
        private loadingCtrl: LoadingController
    ) {
    }

    ionViewDidLoad() {
        console.log("ionViewDidLoad RegisterPage");
    }

    save() {
        const loader = this.loadingCtrl.create({
            content: "Please wait..."
        });
        loader.present();

        this.accountProvider.register(this.model).subscribe(resp => {
            this.isSuccessed = true;
            loader.dismiss();
        }, err => {
            loader.dismiss();
        });
    }

    showSuccess() {
        const alert = this.alertCtrl.create({
            title: "Thành Công",
            subTitle: "Thông tin của bạn đã được cập nhật thành công vào hệ thống.",
            buttons: ["Đóng"]
        });
        alert.present();
    }
}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts